export enum PermissionsEnum {
  'CAN_VIEW_RESTAURANT_DETAILS' = 'CAN_VIEW_RESTAURANT_DETAILS',
  'CAN_EDIT_RESTAURANT_DETAILS' = 'CAN_EDIT_RESTAURANT_DETAILS',
  'CAN_VIEW_RESTAURANT_CHARGES' = 'CAN_VIEW_RESTAURANT_CHARGES',
  'CAN_EDIT_RESTAURANT_CHARGES' = 'CAN_EDIT_RESTAURANT_CHARGES',
  'CAN_VIEW_OFFLINE_PLATFORM' = 'CAN_VIEW_OFFLINE_PLATFORM',
  'CAN_EDIT_OFFLINE_PLATFORM' = 'CAN_EDIT_OFFLINE_PLATFORM',
  'CAN_VIEW_RESTAURANT_MISC_SETTINGS' = 'CAN_VIEW_RESTAURANT_MISC_SETTINGS',
  'CAN_EDIT_RESTAURANT_MISC_SETTINGS' = 'CAN_EDIT_RESTAURANT_MISC_SETTINGS',
  'CAN_ADD_ITEM_TO_ORDER' = 'CAN_ADD_ITEM_TO_ORDER',
  'CAN_VOID_ITEM_FROM_ORDER' = 'CAN_VOID_ITEM_FROM_ORDER',
  'CAN_DECLINE_ORDER' = 'CAN_DECLINE_ORDER',
  'CAN_DELETE_ORDER' = 'CAN_DELETE_ORDER',
  'CAN_ADD_DISCOUNT_TO_ORDER' = 'CAN_ADD_DISCOUNT_TO_ORDER',
  'CAN_TABLE_TRANSFER' = 'CAN_TABLE_TRANSFER',
  'CAN_REVERT_ORDER' = 'CAN_REVERT_ORDER',
  'CAN_VIEW_MENU_ITEM' = 'CAN_VIEW_MENU_ITEM',
  'CAN_EDIT_MENU_ITEM' = 'CAN_EDIT_MENU_ITEM',
  'CAN_CHANGE_MENU_ITEM_VISIBILITY' = 'CAN_CHANGE_MENU_ITEM_VISIBILITY',
  'CAN_CHANGE_MENU_ITEM_AVAILABILITY' = 'CAN_CHANGE_MENU_ITEM_AVAILABILITY',
  'CAN_VIEW_REPORT' = 'CAN_VIEW_REPORT',
  'CAN_GENERATE_EOD' = 'CAN_GENERATE_EOD',
  'CAN_OPEN_CASHIER' = 'CAN_OPEN_CASHIER',
  'CAN_CLOSE_CASHIER' = 'CAN_CLOSE_CASHIER',
  'CAN_CASH_IN' = 'CAN_CASH_IN',
  'CAN_CASH_OUT' = 'CAN_CASH_OUT',
  'CAN_DRAWER_KICK' = 'CAN_DRAWER_KICK',
  'CAN_VIEW_STAFF_SETTINGS' = 'CAN_VIEW_STAFF_SETTINGS',
  'CAN_EDIT_STAFF_SETTINGS' = 'CAN_EDIT_STAFF_SETTINGS',
  'CAN_VIEW_STAFF_ATTENDANCE_STATUS' = 'CAN_VIEW_STAFF_ATTENDANCE_STATUS',
  'CAN_CHANGE_STAFF_ATTENDANCE_STATUS' = 'CAN_CHANGE_STAFF_ATTENDANCE_STATUS',
  'CAN_VIEW_TABLE_SETTINGS' = 'CAN_VIEW_TABLE_SETTINGS',
  'CAN_EDIT_TABLE_SETTINGS' = 'CAN_EDIT_TABLE_SETTINGS',
  'CAN_VIEW_SECTION_SETTINGS' = 'CAN_VIEW_SECTION_SETTINGS',
  'CAN_EDIT_SECTION_SETTINGS' = 'CAN_EDIT_SECTION_SETTINGS',
  'CAN_VIEW_PRINTER_SETTINGS' = 'CAN_VIEW_PRINTER_SETTINGS',
  'CAN_EDIT_PRINTER_SETTINGS' = 'CAN_EDIT_PRINTER_SETTINGS',
  'CAN_VIEW_LOYALTY_SETTINGS' = 'CAN_VIEW_LOYALTY_SETTINGS',
  'CAN_EDIT_LOYALTY_SETTINGS' = 'CAN_EDIT_LOYALTY_SETTINGS',
  'CAN_VIEW_INVENTORY_LIST' = 'CAN_VIEW_INVENTORY_LIST',
  'CAN_EDIT_INVENTORY_LIST' = 'CAN_EDIT_INVENTORY_LIST',
  'CAN_VIEW_PROMOTION' = 'CAN_VIEW_PROMOTION',
  'CAN_EDIT_PROMOTION' = 'CAN_EDIT_PROMOTION',
  'CAN_VIEW_TABLE_SERVICE' = 'CAN_VIEW_TABLE_SERVICE',
  'CAN_TAKE_ACTION_TABLE_SERVICE' = 'CAN_TAKE_ACTION_TABLE_SERVICE',
  'CAN_VIEW_RESTAURANT_ANALYTICS' = 'CAN_VIEW_RESTAURANT_ANALYTICS',
  'CAN_VIEW_HQ' = 'CAN_VIEW_HQ',
  'CAN_VIEW_HQ_OUTLETS' = 'CAN_VIEW_HQ_OUTLETS',
  'CAN_EDIT_HQ_OUTLETS' = 'CAN_EDIT_HQ_OUTLETS',
  'CAN_VIEW_HQ_REPORT' = 'CAN_VIEW_HQ_REPORT',
  'CAN_GENERATE_HQ_EOD' = 'CAN_GENERATE_HQ_EOD',
  'CAN_VIEW_HQ_STAFF_SETTINGS' = 'CAN_VIEW_HQ_STAFF_SETTINGS',
  'CAN_EDIT_HQ_STAFF_SETTINGS' = 'CAN_EDIT_HQ_STAFF_SETTINGS',
  'CAN_DOWNLOAD_HQ_STAFF_DATA' = 'CAN_DOWNLOAD_HQ_STAFF_DATA',
  'CAN_PROVIDE_HQ_ACCESS' = 'CAN_PROVIDE_HQ_ACCESS',
  'CAN_PROVIDE_HQ_POS_ACCESS' = 'CAN_PROVIDE_HQ_POS_ACCESS',
  'CAN_VIEW_HQ_ROLES' = 'CAN_VIEW_HQ_ROLES',
  'CAN_EDIT_HQ_ROLES' = 'CAN_EDIT_HQ_ROLES',
  'CAN_VIEW_HQ_TABLE_SETTINGS' = 'CAN_VIEW_HQ_TABLE_SETTINGS',
  'CAN_EDIT_HQ_TABLE_SETTINGS' = 'CAN_EDIT_HQ_TABLE_SETTINGS',
  'CAN_DOWNLOAD_HQ_SETTLEMENT_SUMMARY' = 'CAN_DOWNLOAD_HQ_SETTLEMENT_SUMMARY',
  'CAN_VIEW_HQ_SETTLEMENT' = 'CAN_VIEW_HQ_SETTLEMENT',
  'CAN_VIEW_HQ_INVENTORY_LIST' = 'CAN_VIEW_HQ_INVENTORY_LIST',
  'CAN_EDIT_HQ_INVENTORY_LIST' = 'CAN_EDIT_HQ_INVENTORY_LIST',
  'CAN_VIEW_HQ_PROMOTION_SETTINGS' = 'CAN_VIEW_HQ_PROMOTION_SETTINGS',
  'CAN_EDIT_HQ_PROMOTION_SETTINGS' = 'CAN_EDIT_HQ_PROMOTION_SETTINGS',
  'CAN_VIEW_HQ_RESTAURANT_ANALYTICS' = 'CAN_VIEW_HQ_RESTAURANT_ANALYTICS',
  'CAN_VIEW_HQ_LOYALTY_SETTINGS' = 'CAN_VIEW_HQ_LOYALTY_SETTINGS',
  'CAN_EDIT_HQ_LOYALTY_SETTINGS' = 'CAN_EDIT_HQ_LOYALTY_SETTINGS',
  'CAN_MARK_ORDER_COMPLETE' =  'CAN_MARK_ORDER_COMPLETE',
  'CAN_SETTLE_OR_MERGE_BILL' = 'CAN_SETTLE_OR_MERGE_BILL',
  'CAN_MODIFY_TABLE_RESERVATION' = 'CAN_MODIFY_TABLE_RESERVATION',
  'CAN_CREATE_HQ_NEW_EXPENSE' = 'CAN_CREATE_HQ_NEW_EXPENSE',
  'CAN_DELETE_HQ_EXPENSE' = 'CAN_DELETE_HQ_EXPENSE',
  'CAN_GENERATE_HQ_PANDL_REPORT' = 'CAN_GENERATE_HQ_PANDL_REPORT',
  'CAN_DELETE_TABLE_SECTION' = 'CAN_DELETE_TABLE_SECTION',
  'CAN_DOWNLOAD_HQ_REPORTS' = 'CAN_DOWNLOAD_HQ_REPORTS',
  'CAN_DOWNLOAD_REPORTS' = 'CAN_DOWNLOAD_REPORTS'
}
